import apiClient from '@/services/axios'

export async function patch(calenderEntryId, calendarDatesByYearlyEntry) {
  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/' + calenderEntryId + '/calendar-dates-by-yearly-interval', calendarDatesByYearlyEntry);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post yearly entry.')
}
